"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var redux_1 = require("redux");

var styled_components_1 = __importStar(require("styled-components"));

var index_1 = require("../index");

var ScrollDown = react_1.default.memo(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      theme = _a.theme,
      scrollToSectionHandler = _a.scrollToSectionHandler;
  var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);

  if (!smallOrMedium) {
    return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(ScrollDownContainer, {
      onPress: scrollToSectionHandler
    }, react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(index_1.InfoText, null, "Scroll Down"), react_1.default.createElement(components_lib_1.ScrollDownAnimation, null))));
  }

  return null;
});
var ScrollDownContainer = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n"], ["\n    display: flex;\n    flex-direction: row;\n"])));
var hoc = redux_1.compose(responsive_1.withResponsiveMeta, styled_components_1.withTheme);
exports.default = hoc(ScrollDown);
var templateObject_1;